/**
 * DevExtreme (esm/__internal/ui/drop_down_editor/m_utils.js)
 * Version: 23.2.10
 * Build date: Mon Oct 28 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import {
    getOuterWidth
} from "../../../core/utils/size";
import {
    hasWindow
} from "../../../core/utils/window";
var getElementWidth = function($element) {
    if (hasWindow()) {
        return getOuterWidth($element)
    }
};
var getSizeValue = function(size) {
    if (null === size) {
        size = void 0
    }
    if ("function" === typeof size) {
        size = size()
    }
    return size
};
export {
    getElementWidth,
    getSizeValue
};
